import React from "react";
import { FaNewspaper } from "react-icons/fa";
import Loader from "../../../components/Loader/Loader";
import { useStudentNewsroom } from "./hooks/useStudentNewsroom";
import "./Newsroom.css";

// title.rendered is WP's escaped HTML (e.g. "Alumni &amp; Friends Meet") —
// it's meant to be plain text, just entity-decoded, so this decodes it via
// a detached <textarea> instead of dangerouslySetInnerHTML'ing a headline.
const decodeHtmlEntities = (value) => {
  if (!value) return "";
  const textarea = document.createElement("textarea");
  textarea.innerHTML = value;
  return textarea.value;
};

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

const StudentNewsroom = () => {
  const {
    categories,
    activeCategoryId,
    setActiveCategoryId,
    posts,
    isLoadingCategories,
    isLoadingPosts,
  } = useStudentNewsroom();

  if (isLoadingCategories) {
    return <Loader />;
  }

  return (
    <div className="student-newsroom">
      <h2 className="sp-section-title">Apeejay Newsroom</h2>

      {categories.length === 0 ? (
        <div className="sp-card sp-empty-state">
          <FaNewspaper size={28} />
          <p className="mb-0">No newsroom categories are available right now.</p>
        </div>
      ) : (
        <>
          <div className="student-newsroom-tabs" role="tablist">
            {categories.map((category) => {
              const isActive = category?.id === activeCategoryId;
              return (
                <button
                  key={category.id}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  className={`student-newsroom-tab${isActive ? " is-active" : ""}`}
                  onClick={() => setActiveCategoryId(category.id)}
                >
                  {category.name}
                </button>
              );
            })}
          </div>

          {isLoadingPosts ? (
            <Loader />
          ) : posts.length === 0 ? (
            <div className="sp-card sp-empty-state">
              <FaNewspaper size={28} />
              <p className="mb-0">No posts have been published in this category yet.</p>
            </div>
          ) : (
            <div className="student-newsroom-list">
              {posts.map((post) => {
                const thumbnail = post?._embedded?.["wp:featuredmedia"]?.[0]?.source_url;
                const headline = decodeHtmlEntities(post?.title?.rendered);

                return (
                  <a
                    key={post.id}
                    href={post.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="student-newsroom-link"
                  >
                    <div className="sp-card sp-card--hoverable student-newsroom-card">
                      {thumbnail && (
                        <img
                          src={thumbnail}
                          alt=""
                          className="student-newsroom-thumb"
                        />
                      )}
                      <div className="student-newsroom-copy">
                        <p className="student-newsroom-published">PUBLISHED / {formatDate(post.date)}</p>
                        <h6 className="student-newsroom-headline">{headline}</h6>
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default StudentNewsroom;
